import Button from "@src/components/UIElements/Button";
import Modal from "@src/components/UIElements/Modal";
import { Image } from "@src/components/Image";
import React, { useEffect } from "react";
import styles from "./PaymentFailedBottomSheet.module.scss";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import { getCourseDetailsAction } from "@src/components/Tabs/Overview/store/actions";
import { handleRetryOption } from "@src/PaymentService";
import { newWebEngage } from "@src/utils/webEngageEvent";
import { courseFacultyListModalAction } from "@src/components/BottomSheets/store/actions";
import { hitDeeplinkExecutedV2 } from "@src/utils/hitDeeplink";
import { getTabListAction } from "../../../UIElements/TabBar/store/actions";
import { EVENTS_NAME_MAPPING } from "@src/utils/constants";

const PaymentFailedBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showPaymentFailedBottomSheet
  );
  const prevOrderId = useSelector(
    (state) => state?.overviewReducer?.prevOrderId
  );

  const courseId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.id
  );

  const courseName = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.details?.name
  );

  let appliedCoupon = useSelector((state) => {
    return state?.overviewReducer?.graphCourseData?.appliedCoupon;
  });

  let priceValue = useSelector((state) => {
    return state?.overviewReducer?.graphCourseData?.priceBottom?.val;
  });
  let orgDetails = useSelector((state) => {
    return state?.persistedDataReducer?.orgDetails?.organization;
  });
  let userDetails = useSelector((state) => {
    return state?.overviewReducer?.userDetails?.responseData?.user;
  });

  const isComboActive = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isComboActive
  );

  const courseDetails = useSelector((state) => {
    return state?.overviewReducer?.overViewDetails?.course;
  });
  const isPaymentSupportEnabled = useSelector((state) => state?.persistedDataReducer?.orgDetails?.organization?.isPaymentSupportEnabled)
  const isTrialContentEnabled = useSelector((state) => state?.persistedDataReducer?.orgDetails?.organization?.isTrialContentEnabled)
  const isPaymentProEnabled = useSelector((state) => state?.persistedDataReducer?.orgDetails?.organization?.isPaymentProEnabled)
  const token = localStorage.getItem("userToken");
  const orderId = localStorage.getItem("orderId");
  let paymentSupportDeeplink = null;

  if(isPaymentProEnabled && isPaymentSupportEnabled){
    paymentSupportDeeplink = {
        "screen": "UTIL_WEBVIEW",
        "paramOne": `https://payment-help.classplus.co/?courseId=${courseId}&token=${token}&orderId=${orderId}&environment=${import.meta.env.VITE_ENV?.toLowerCase()}`,
        "paramThree": "1"
    }
  }
  useEffect(() => {
    // console.log(data);
    if (courseName && priceValue && orgDetails?.code && userDetails) {
      newWebEngage("course_payment_failed", {
        action: "Payment Failed",
        course_name: `${courseName}`,
        amount: priceValue / 100,
        is_installment: window.is_installment,
        item: [
          {
            item_id: courseDetails?.metaData?.id, 
            item_name: courseDetails?.details?.name, 
            item_category: courseDetails?.categoryList,
            price: courseDetails?.priceDetails?.coursePrice
          }
        ],
        ...(appliedCoupon?.code
          ? {
              coupon_code: appliedCoupon?.code + "",
              is_coupon_applied: appliedCoupon?.redeemId ? true : false,
            }
          : { is_coupon_applied: false }),
      });
    }
    if (window.is_installment) window.is_installment = false;
  }, [courseName, priceValue, orgDetails, userDetails]);

  // REFRESHING OVERVIEW DATA
  useEffect(() => {
    if(isPaymentSupportEnabled){
      dispatch(
        getCourseDetailsAction({
          courseId: courseId,
          isLoading: false,
          showPaymentLoader: false,
        })
      );
    }
  }, [courseId])

  useEffect(()=> {
    if (isTrialContentEnabled && courseId) {
      dispatch(
        getTabListAction({
          courseId,
          skipLoader: true,
        })
      );
    }
  },[])
  
  return (
    <Modal
      showModal={state}
      handleClose={() => {
        dispatch(
          getCourseDetailsAction({
            courseId: courseId,
            isLoading: false,
          })
        );
        dispatch(actionCreator.showPaymentFailedBottomSheetAction(false));
      }}
    >
      <div className={styles.PaymentFailed}>
        <div className={styles.PaymentFailed__image}>
          {/* todo change the image icon to gif */}
          <Image
            src={getAwsAssets("Paymentfailed.svg", "content")}
            alt={t(
              "components.bottomSheets.components.paymentFailedBottomSheet.rupeeIcon",
              "RupeeIcon"
            )}
            width="74px"
            height="74px"
          />
        </div>
        <h1 className={styles.PaymentFailed__heading}>
          {t(
            "components.bottomSheets.components.paymentFailedBottomSheet.paymentFailed",
            "Payment unsuccessful!"
          )}
        </h1>
        <p className={styles.PaymentFailed__subtext}>
          {
          t(
            "components.bottomSheets.components.paymentFailedBottomSheet.paymentNotCompleted",
            "Your payment for this course could not be completed. Please retry again."
          )}
        </p>
        <Button
          onClick={() => {
            if (isComboActive === 1) {
              dispatch(courseFacultyListModalAction(true));
              dispatch(actionCreator.showPaymentFailedBottomSheetAction(false));
            } else {
              dispatch(actionCreator.showPaymentFailedBottomSheetAction(false));
              handleRetryOption(prevOrderId);
            }
          }}
        >
          {t(
            "components.bottomSheets.components.paymentFailedBottomSheet.retryPayments",
            "Retry Payment"
          )}
        </Button>
        {paymentSupportDeeplink && (
          <Button
            onClick={() => {
              hitDeeplinkExecutedV2(
                JSON.stringify(paymentSupportDeeplink),
                JSON.stringify(paymentSupportDeeplink)
              );
              newWebEngage(EVENTS_NAME_MAPPING.contactSupportNeedHelp, {
                org_id: orgDetails?.id + "",
                cp_user_id: Number(userDetails?.id),
                date_and_time: new Date(),
              });
            }}
            customClassName={styles.PaymentFailed__needHelp}
          >
            {t(
              "components.bottomSheets.components.paymentFailedBottomSheet.needHelp",
              "Need help ?"
            )}
          </Button>
        )} 
      </div>
    </Modal>
  );
};

export default PaymentFailedBottomSheet;
